import React, { useState, useEffect } from "react";
import { Col, Modal, ModalBody, Row, Label, Button } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";

import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
// Redux
import { useSelector } from "react-redux";

import { casosCreate } from "../../../../store/casos/actions";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { contactsFulllist } from "../../../../store/contacts/actions";
import { grupotecnicoList } from "../../../../store/grupoTecnico/actions";
import CrearContactoModal from "./CrearContactoModal";

import Select from "react-select";
import "../../../../assets/scss/stylebuttonModal.scss";
const CrearModal = ({
  crearModal,
  onCloseClick,
  isEdit,
  contactFilter,
  handleDeleteEvent,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(contactsFulllist());

    dispatch(grupotecnicoList());
  }, [dispatch]);

  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);

  const contact = useSelector((state) => state.Contacts.contacts) || [];
  const [selectedContacto, setSelelectedContacto] = useState(null);

  function handleSelectContacto(selectedContacto) {
    setSelelectedContacto(selectedContacto.value);
  }

  const [formData, setFormData] = useState({
    direccion_1: "",
    direccion_2: "",
    observaciones: "",
    tecnico_asignado: [contactFilter?.id],
  });

  const { direccion_1, direccion_2, observaciones, tecnico_asignado } =
    formData;

  const onChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setFormData({ ...formData, [e.target.name]: uppercaseValue });
  };

  console.log(formData);
  const handleButtonClick = () => {
    onCloseClick(); // Llama a la función onCloseClick pasada como prop desde el componente padre
  };

  const callDeleteClick = () => {
    handleDeleteEvent();
  };

  const [image, setFormDataImage] = useState([]);

  const handleImageChange = (evImages) => {
    Array.from(evImages).forEach((image) => {
      var reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = function () {
        var img = [];
        var base64 = reader.result;
        img = base64.split(",");
        setFormDataImage((prevImages) => [...prevImages, { image: img[1] }]);
      };
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const data = {
      direccion_1,
      direccion_2,
      observaciones,
      modelo_desplazamiento: true,
      tecnico_asignado:
        selectedContacto === null ? tecnico_asignado : [selectedContacto],
      images: image,
    
    };

    // console.log(data)

    dispatch(casosCreate(data));
  };

  const [crearContactoModal, setCrearContactoModal] = useState(false);

  const handleContactoClick = (selected) => {
    setCrearContactoModal(true);
  };

  const handleCloseContactoModal = () => {
    setCrearContactoModal(false);
  };

  return (
    <React.Fragment>
      {crearContactoModal ? (
        <CrearContactoModal
          style={{ overflow: "auto", zIndex: "100" }}
          crearContactoModal={crearContactoModal}
          onCloseClick={handleCloseContactoModal}
        ></CrearContactoModal>
      ) : null}

      <Modal isOpen={crearModal} toggle={onCloseClick} centered={true}>
        <div className="modal-header">
          <h3 className="modal-title mt-2">Caso Desplazamiento</h3>

          <button
            type="button"
            className="btn btn-primary button-10-width "
            onClick={() => {
              onCloseClick();
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <ModalBody>
          <AvForm onSubmit={onSubmit}>
            <Row form>
              <Row>
                <AvField
                  name="direccion_1"
                  label="DIRECCION 1"
                  type="text"
                  errorMessage="Invalid name"
                  onChange={onChange}
                  value={direccion_1}
                />
              </Row>
              <Row>
                <AvField
                  name="direccion_2"
                  label="DIRECCION 2"
                  type="text"
                  errorMessage="Invalid name"
                  onChange={onChange}
                  value={direccion_2}
                />
              </Row>

              <Col>
                <Label
                  for="observaciones"
                  className="col-form-label col-sm-4 d-flex"
                >
                  OBSERVACIONES
                </Label>

                <textarea
                  className="form-control"
                  id="observaciones"
                  name="observaciones"
                  type="textarea"
                  rows="4"
                  onChange={onChange}
                  value={observaciones}
                />
              </Col>

              <Col>
                <Label
                  for="image_file"
                  className="col-form-label col-sm-4 d-flex"
                >
                  IMAGENES (OPCIONAL)
                </Label>

                <input
                  className="form-control"
                  id="image_file"
                  name="image_file"
                  type="file"
                  multiple={true}
                  onChange={(e) => handleImageChange(e.target.files)}
                />
              </Col>

              {groups === "SuperAdmin" || groups === "Supervisor" ? (
                <>
                  <Row style={{ marginBottom: "10px", marginTop: "10px" }}>
                    <Col className="col-8">
                      <Label
                        for="accountlist"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        ASIGNADO A
                      </Label>

                      <Select
                        id="accountlist"
                        name="accountlist"
                        placeholder="Seleccione"
                        onChange={handleSelectContacto}
                        options={
                          contact &&
                          contact.map((item) => ({
                            label: item.first_name
                              ? item.first_name
                              : item.razon_social,
                            value: item.id,
                          }))
                        }
                      />
                    </Col>

                    <Col className="col-4" style={{ marginTop: "auto" }}>
                      <Button onClick={handleContactoClick}>
                        AGREGAR CONTACTO
                      </Button>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Row>

            {/* Botones de abajo */}
            <Row>
              <Col>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={handleButtonClick}
                  >
                    CERRAR
                  </button>
                  {!!isEdit && (
                    <button
                      type="button"
                      className="btn btn-danger me-2"
                      onClick={callDeleteClick}
                    >
                      BORRAR
                    </button>
                  )}
                  <button type="submit" className="btn btn-success save-event">
                    GUARDAR
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, casos, casosCreated } = state.Casos;
  return { error, loading, casos, casosCreated };
};

CrearModal.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  casosCreated: PropTypes.object,
};

export default withRouter(
  connect(mapStateToProps, { casosCreate })(CrearModal)
);
